<template>
	<component :is="tag" :to="to" class="rb-thumbnail" :class="{active}">
		<div class="spacer" :class="{ square }"></div>
		<transition name="fade">
			<img :src="imageUrl" alt="" @load="onImgLoad" v-show="imgLoaded">
		</transition>
		<div class="rb-thumbnail-overlay"></div>

		<div class="rb-thumbnail-head px-3 py-2">
			<slot name="head"></slot>
		</div>

		<div class="rb-thumbnail-center text-center">
			<slot name="center"></slot>
		</div>

		<div class="rb-thumbnail-footer px-3 py-2">
			<slot name="footer"></slot>
		</div>
	</component>
</template>

<script>

	export default {
		name: 'RbThumbnail',
		props: {
			imageUrl: {
				type: String,
				required: true
			},
			active: {
				type: Boolean,
				default: false
			},
			square: {
				type: Boolean,
				default: false
			},
			to: {
				type: [String, Object],
				default: ''
			}
		},
		data: () => ({
			imgLoaded: false
		}),
		computed: {
			tag() {
				if (this.to) {
					return 'router-link';
				}

				return 'div';
			}
		},
		methods: {
			onImgLoad() {
				this.imgLoaded = true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-thumbnail {
		position: relative;
		display: block;
		background: rgba($dark, .9);

		.spacer {
			padding:27.895% 0; // 16:9
			display:inline-block;

			&.square {
				padding:50% 0; // 1?1
			}
		}

		&.active {
			cursor: pointer;
		}

		> img {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;

			object-fit: cover;
		}

		.rb-thumbnail-overlay {
			background: linear-gradient(to bottom, rgba(0, 0, 0, .9) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, .5) 100%);
			opacity: .5;
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;

			transition: all .5s ease;
		}

		&.active:hover {
			.rb-thumbnail-overlay {
				opacity: 1;
			}
		}

		.rb-thumbnail-head {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
		}
		.rb-thumbnail-center {
			position: absolute;
			left: 0;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
		}
		.rb-thumbnail-footer {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
		}
	}
</style>
